var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('MobilePromoCard',{attrs:{"icon":"bell","title":_vm.$t('mobile.pushBannerTitle'),"subtitle":_vm.hint || _vm.$t('mobile.pushBannerSubtitle'),"cta-label":_vm.$t('mobile.pushBannerButton'),"busy":_vm.busy},on:{"cta":_vm.enable}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }